import { render } from "./AddHistorique.vue?vue&type=template&id=08d80ae3&ts=true"
import script from "./AddHistorique.vue?vue&type=script&lang=ts"
export * from "./AddHistorique.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__